<template>
  <div class="flow-container">
    <div class="header">
      <div class="title">结算汇总信息查询</div>
      <p class="red-notice in-header">注意：因系统升级，此页面部所统计的信息可能有误，如需查询单费用明细，请使用【费用明细】页面进行查询或导出；如需导出汇总报表，请移步到【对账单导出】页面进行导出。</p>
    </div>
    <div class="search-form">
      <el-form inline class="inline-form" :model="flowForm" label-width="80px" label-position="left">
        <div>
          <el-form-item label="时间">
            <cumstom-date-time-range @change="changeDateTimeRange"></cumstom-date-time-range>
          </el-form-item>
        </div>
        <div>
            <el-form-item label="汇总统计">
                <div class="type" style="display: flex;">
                    <div :class="{item: true, active: summaryType === 1}" @click="changeTable(1)">交易汇总</div>
                    <div :class="{item: true, active: summaryType === 2}" @click="changeTable(2)">门店汇总</div>
                    <div :class="{item: true, active: summaryType === 3}" @click="changeTable(3)">收银点汇总</div>
                    <div :class="{item: true, active: summaryType === 4}" @click="changeTable(4)">收款方式汇总</div>
                </div>
            </el-form-item>
        </div>
        <div v-if="summaryType === 4">
          <el-form-item label="选择门店">
            <el-select v-model="store">
              <el-option v-for="item in stores" :key="item.key" :label="item.merchantName" :value="item.merchantId"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <span class="btn-box">
            <el-button type="primary" @click="search" class="bs-btn" :disabled="btnCanNotClick" :class="{ 'save-btn-active': btnCanNotClick }">查询</el-button>
          </span>
        </div>
      </el-form>
    </div>
    <div class="table-data">
      <div class="table-data-con">
        <table-page :data="tableData" :tableColumns="tableColumns"  :paginations="page" :loading="loadingTable" @onChangeCurrentPage="onChangeCurrentPage">
            <!-- <template slot-scope="scope">
              <span class="view-detail" @click="viewFlowDetial(scope.row,false)">查看</span>
              <span class="view-detail view-refund" v-if="ifRefundShow(scope.row)" @click="viewFlowDetial(scope.row,true)">退款</span>
            </template> -->
        </table-page>
      </div>
    </div>
  </div>
</template>
<script>
// import dayjs from "dayjs";
import CumstomDateTimeRange from "./CustomDateTimeRange.vue";
import allShopSummaryList from "@/api/settlement-query";
import { formatDate } from "@/utils/index";
import { queryShopList } from "@/api/merchant-info";
import tablePage from '@/components/tablePage/index.vue';
// import { host } from "@/global-config";
import {
  sunmary, storesc, pointc, wayc,
} from './columns';

export default {
  name: "settlement",
  components: {
    CumstomDateTimeRange,
    tablePage,
  },
  data() {
    return {
      btnCanNotClick: false,
      columns: [sunmary,
        storesc,
        pointc,
        wayc],
      tableColumns: sunmary,
      flowForm: {
        startTime: "",
        endTime: "",
      },
      loadingTable: false,
      stores: [], // 门店数据
      store: '',
      page: {
        pageNo: 1,
        total: 0,
        pageSize: 10,
      },
      tableData: [],
      summaryType: 1,
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    changeTable(val) {
      this.summaryType = val;
      this.tableColumns = this.columns[val - 1];
      this.page = {
        pageNo: 1,
        total: 0,
        pageSize: 10,
      };
      this.search();
    },
    changeDateTimeRange(dateTimeRange) {
      const date = new Date().getTime();
      // 日期是否包含今天
      if (formatDate(date) === formatDate(dateTimeRange[1])) {
        this.flowForm.startTime = formatDate(dateTimeRange[0]);
        this.flowForm.endTime = formatDate(dateTimeRange[1]);
      } else {
        this.flowForm.startTime = formatDate(dateTimeRange[0]);
        this.flowForm.endTime = formatDate(dateTimeRange[1]);
      }
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryShopList();
    },
    search() {
      const startm = new Date(this.flowForm.startTime).getMonth() + 1;
      const endm = new Date(this.flowForm.endTime).getMonth() + 1;
      if (startm !== endm) {
        this.$message({
          showClose: true,
          message: "查询时间不可跨月",
          type: "error",
        });
        return;
      }
      this.page.pageNo = 1;
      this.queryShopList();
    },
    // 获取列表
    queryShopList() {
      const params = {
        ...this.flowForm,
        ...this.page,
        summaryType: this.summaryType,
      };
      if (this.summaryType === 4) {
        params.merchantId = this.store;
      }
      this.loadingTable = true;
      allShopSummaryList(params).then((res) => {
        this.loadingTable = false;
        if (res.data.error_code === 0) {
          if (Number(this.summaryType) === 1 || Number(this.summaryType) === 4) {
            this.page.total = 0;
            const resD = res.data.data;
            this.tableData = Array.isArray(resD) ? resD : [resD];
          } else {
            this.page.total = res.data.data.totalCount;
            this.tableData = res.data.data.list;
          }
        }
      });
    },
    // 查看详情
    viewFlowDetial(row, ifRefund) {
      if (ifRefund) {
        this.refundDialogViewDetial = true;
      } else {
        this.dialogViewDetial = true;
      }
      this.transDetial = row;
    },
    // 获取门店
    getStoreList() {
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo: 1,
        pageSize: 1000,
      };
      queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          this.stores = res.data.data.list;
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.refundInter);
    clearTimeout(this.refundTimeout);
  },
  mounted() {
    const that = this;
    this.getStoreList();
    this.$nextTick(() => {
      that.queryShopList();
    });
  },
};
</script>
<style lang="scss" scoped>
.refund-btn {
  background-color: #1395ff !important;
}

.refund-btn-grey {
  color: #666 !important;
  background-color: #ececec !important;
}

.view-refund {
  margin-left: 10px;
  color: #ff9c00 !important;
}

.refund-step-two {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;

  span {
    margin-top: 30px;
    font-size: 22px;
    color: #333;
  }

  div {
    margin-top: 20px;
    font-size: 16px;
    color: #999;
  }
}

.flow-container {
  > .header {
    position: relative;
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    overflow: hidden;
    border-bottom: 20px solid #eee;

    .el-form-item.el-form-item__label {
      height: 32px;
      font-size: 14px;
      line-height: 32px;
    }

    .time-label {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .el-form--inline .el-form-item__label {
      font-size: 14px;
      font-weight: 400;
      color: #333;

      .el-form-item__content {
        overflow: hidden;
      }
    }

    .el-tag__close {
      font-size: 16px;
    }

    .middle-sele {
      margin-right: 40px;
    }

    .trans-amount {
      margin-top: 3px;

      .el-form-item__content {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }

      .el-input__inner {
        border: none;
      }
    }

    .btn-base {
      width: 90px;
      height: 32px;
      line-height: 0px;
      background: #1395ff;
      border: none;
    }

    .save-btn-active {
      color: #666;
      background: #ececec !important;
    }

    .btn-box {
      float: right;
    }

    .line {
      display: inline-block;
      width: 10px;
      height: 2px;
      margin-right: 10px;
      vertical-align: middle;
      background: #999;
    }

    .el-select .el-select__tags {
      margin-top: 4px;
    }

    .el-select .el-select__tags > span {
      display: flex;
    }

    .middle-sele .el-select .el-select__tags {
      margin-top: 0;
    }

    .el-tag.el-tag--info {
      display: flex;
      align-items: center;
      max-width: 100%;
    }
  }

  .table-data {
    overflow: hidden;
    background: #f7f7f7;

    .table-data-con {
      padding: 40px 50px;
      overflow: hidden;
      background: #fff;

      .view-detail {
        color: #1395ff;
        cursor: pointer;
      }
    }
  }

  .view-detail {
    .el-dialog {
      border-radius: 6px;
    }

    .el-dialog__header {
      padding: 40px 30px 0 40px;
    }

    .el-dialog__body {
      padding: 00 30px 0 40px;
    }

    .el-dialog__footer {
      padding-bottom: 50px;
      margin-top: 45px;
      text-align: center;

      .el-button {
        width: 120px;
        height: 38px;
        background: #ff9c00;
        border: none;
      }
    }

    .content {
      .one-part {
        margin-top: 35px;
        font-size: 14px;

        .item-info {
          display: flex;
          margin-top: 20px;
        }

        .title {
          width: 100px;
          color: #999;
        }

        .el-input-number {
          display: block;
        }

        .text {
          font-weight: 400;
          color: #333;
        }

        .title-input {
          line-height: 40px;

          .el-button {
            margin-left: 24px;
            color: #1395ff;
          }
        }
      }
    }
  }
}

.type {
  .item {
    flex: 1;
    width: 100px;
    min-width: 100px;
    height: 32px;
    margin-right: 14px;
    font-size: 14px;
    line-height: 32px;
    color: #5e5e63;
    text-align: center;
    cursor: pointer;
    border: 1px solid #dde0e7;

    &.active {
      color: #008cff;
      border: 1px solid #008cff;
    }
  }
}
</style>
